import { useCallback } from 'react';

import { useApiFreelancerPartialUpdate } from 'state/__generated__/tadaahAPI';

import client from 'state/remote/client';

interface UseSubmitFreelancerApplication {
  isLoading: boolean;
  submitApplication: () => void;
}
const useSubmitFreelancerApplication = (): UseSubmitFreelancerApplication => {
  const { isLoading, mutateAsync } = useApiFreelancerPartialUpdate({
    mutation: {
      mutationKey: 'update-freelancer-ready-for-verification',

      onSuccess: () => {
        const queriesToInvalidate = [
          'freelancer-profile',
          'freelancer-details',
        ];
        queriesToInvalidate.forEach((query) => client.invalidateQueries(query));
      },
    },
  });

  const submitApplication = useCallback(async () => {
    const response = await mutateAsync({
      // @ts-expect-error wrong type information
      data: {
        ready_for_verification: true,
      },
    });
    if (response.status !== 200) throw new Error('Something went wrong');
  }, [mutateAsync]);

  return { isLoading, submitApplication };
};

export default useSubmitFreelancerApplication;
